import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { persistStore, persistReducer } from 'redux-persist';
import authReducer from './auth/authSlice';
import vendorReducer from './auth/vendorSlice';
import summaryReducer from './user/summarySlice';
import favoriteReducer from './user/favoriteSlice';
import winRatioReducer from './user/winratioSlice';
import facilityReducer from './user/selectfacilitySlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'vendor', 'summary', 'favorite', 'winRatio'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  vendor: vendorReducer,
  summary: summaryReducer,
  favorite: favoriteReducer,
  winRatio: winRatioReducer,
  selectFacilities: facilityReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);

export default store;